import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Heading6 } from '@ui/Typography'

import { useGAEvents } from '@utils/callGAEvents'

import { IBTestSubCategory } from '@model/TestSectionsDto'

import { Modal } from '@global/modal/Modal'

import { IBCarousel } from '../Carousel/IBCarousel'
import { BecomeIBModal } from './BecomeIBModal'
import { EarnRewardsModal } from './EarnRewardsModal'
import { IBSignUpForm } from './IBSignUpForm'

import styles from './IBSignUpTypePage.module.scss'

interface Props {
  isProfile?: boolean
}

export const IBSignUpTypePage: React.FC<Props> = ({ isProfile }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { callGAEvents } = useGAEvents()
  const [becomeIBModal, setBecomeIBModal] = useState(false)
  const [earnRewardsModal, setEarnRewardsModal] = useState(false)

  const [subCategoryId, setSubCategoryId] = useState<IBTestSubCategory>()

  const signUpNextStep = async () => {
    callGAEvents().IBQuestionnaire.Actions.submit()
    if (isProfile) {
      navigate(`/profile/introducing-broker/register/${subCategoryId}/questionnaire`)
    } else {
      navigate(`/dashboard/introducing-broker/register/${subCategoryId}/questionnaire`)
    }
  }

  const handleWhyBecomeIBClick = () => {
    callGAEvents().IBQuestionnaire.InfoLinks.whyBecomeIB()
    setBecomeIBModal(true)
  }

  const handleLoyaltyProgramClick = () => {
    callGAEvents().IBQuestionnaire.InfoLinks.loyaltyProgram()
    setEarnRewardsModal(true)
  }

  return (
    <>
      {becomeIBModal && (
        <Modal
          closeModal={() => setBecomeIBModal(false)}
          render={() => <BecomeIBModal onCancel={() => setBecomeIBModal(false)} />}
        />
      )}
      {earnRewardsModal && (
        <Modal
          closeModal={() => setEarnRewardsModal(false)}
          render={() => <EarnRewardsModal onCancel={() => setEarnRewardsModal(false)} />}
        />
      )}
      <div className={styles.formInputWrapper}>
        <Heading6 medium>{t('IB.Register')}</Heading6>
        <p className='is-link' onClick={handleWhyBecomeIBClick}>
          {t('IB.Why should I become an IB?')}
        </p>
        <p className='is-link' onClick={handleLoyaltyProgramClick}>
          {t('IB.Earn additional rewards with our IB Loyalty Program')}
        </p>
        <IBSignUpForm
          subCategoryId={subCategoryId}
          setSubCategoryId={setSubCategoryId}
          handleSignUp={signUpNextStep}
        />
      </div>
      <IBCarousel subCategoryId={subCategoryId} />
    </>
  )
}
